module.exports = __webpack_public_path__ + "static/media/cash-dollar.c58e0473.svg";